export default __webpack_public_path__ + "media/images/brands/demo/backgrounds/bg-02-a217f2ce55f9cc407255b893f53bd6e8.jpg";